import React from 'react';
import { Link } from "react-router-dom";
import "./mountain.css";
import { FaMountain, FaHiking, FaMapMarkedAlt } from "react-icons/fa";

function MountainAndHiking() {
  const hikingAreas = [
    { name: "Adam’s Peak", highlight: "Spiritual climb with breathtaking sunrise", image: "/adamspeak.jpg" },
    { name: "Knuckles Mountain Range", highlight: "UNESCO heritage site with unique biodiversity", image: "/knuckles.jpg" },
    { name: "Horton Plains", highlight: "Scenic plateau with World’s End viewpoint", image: "/horton.jpg" },
    { name: "Ella Rock", highlight: "Iconic hiking trail with panoramic views", image: "/ella.jpeg" },
    { name: "Pidurangala Rock", highlight: "Overlooks the Sigiriya fortress", image: "/piduran.webp" },
    { name: "Riverston", highlight: "Cool mountain breeze and rolling hills", image: "/rivers.jpg" },
  ];

  return (
    <div className="bird-page">
      {/* Banner */}
      <div className="banner-section">
        <img src="/mountain.webp" alt="Mountain and Hiking" className="banner-image" />
        <div className="banner-content">
          <h1 className="banner-title"><span><b>Mountain &</b></span> Hiking Adventures</h1>
          <div className="banner-description">
            <p>Explore Sri Lanka’s highlands, trek through misty trails, and witness nature’s most stunning landscapes. From challenging climbs to peaceful walks, every hike offers unforgettable experiences.</p>
            <Link to="/booking">
              <button className="book-now-btn">Book Your Adventure Now</button>
            </Link>
          </div>
        </div>
      </div>

      {/* Locations */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Top Hiking Trails</h2>
        <p className="section-subtitle">Discover the most scenic routes in Sri Lanka</p>
        <div className="wildlife-areas-grid">
          {hikingAreas.map((area, i) => (
            <div className="wildlife-area-card" key={i}>
              <div className="area-image-container">
                <img src={area.image} alt={area.name} className="area-image" loading="lazy" />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{area.name}</h3>
                <p>{area.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card"><FaMountain className="icon" /><h3 className="desc-heading">Mountain Treks</h3><p className="desc-para">Conquer Sri Lanka’s highest peaks and enjoy breathtaking scenery.</p></div>
        <div className="info-card"><FaHiking className="icon" /><h3 className="desc-heading">Guided Hikes</h3><p className="desc-para">Join expert-led hiking tours for a safe and enriching experience.</p></div>
        <div className="info-card"><FaMapMarkedAlt className="icon" /><h3 className="desc-heading">Scenic Spots</h3><p className="desc-para">Discover hidden viewpoints and nature’s best-kept secrets.</p></div>
      </section>

      {/* Quote */}
      <section className="quote-section">
        <blockquote>"The best view comes after the hardest climb."</blockquote>
        {/* <cite>— Unknown</cite> */}
      </section>
    </div>
  );
}

export default MountainAndHiking;
